<div class="spinner-container" *ngIf="isLoading$ | async">
  <div class="spinner">
    <mat-spinner diameter="40" aria-label="読み込み中"></mat-spinner>
  </div>
</div>
